import {
  GET_SPECIFIC_PROVIDERS,
  GET_SPECIFIC_PROVIDERS_ERROR,
  GET_SPECIFIC_PROVIDERS_SUCCESS
} from './QuoteProvidersList.actions'

const quoteProvidersListState = {
  page: 0,
  records: [],
  error: null,
  loading: false,
  totalPages: 0,
  totalRecords: 0
}

/**
 * The quote providers list's reducer.
 */
const quoteProvidersListReducer = (state = quoteProvidersListState, { payload, type }) => {
  switch (type) {
    case GET_SPECIFIC_PROVIDERS: {
      return { ...state, loading: true }
    }
    case GET_SPECIFIC_PROVIDERS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_SPECIFIC_PROVIDERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        page: payload.page,
        records: payload.records,
        totalPages: payload.totalPages,
        totalRecords: payload.totalRecords
      }
    }
    default: {
      return state
    }
  }
}

export default quoteProvidersListReducer
